import { render, staticRenderFns } from "./JfList.vue?vue&type=template&id=7db2649c&scoped=true&"
import script from "./JfList.vue?vue&type=script&lang=js&"
export * from "./JfList.vue?vue&type=script&lang=js&"
import style0 from "./JfList.vue?vue&type=style&index=0&id=7db2649c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db2649c",
  null
  
)

export default component.exports